import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';

import { TranslateService } from './services/translate/translate.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PipesModule } from './pipes/pipes.module';
import { IbexErrorService } from './services/error/ibex-error.service';
import { OnlineStatusModule } from 'ngx-online-status';
import { GlobalComponentsModule } from './components/global-components.module';

if (!environment.production) { // develop with live url or local
  /* ------------------- */
  /* enable for live environment in development mode */
  environment.backendUrl = environment.developOnLive.backendUrl;
  /* ------------------- */
}

@NgModule({
  declarations: [
    AppComponent
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    CommonModule,
    FormsModule,
    PipesModule,
    OnlineStatusModule,
    GlobalComponentsModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: IbexErrorService
    },
    TranslateService
  ],
  bootstrap: [AppComponent],
  exports: []

})
export class AppModule {}

